<template>
<v-app>
  <Navbar />
  <v-main>
    <v-container fluid class="pa-0">
      <router-view></router-view>
    </v-container>
  </v-main>
<Footer/> 
</v-app>
</template>

<script>
import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'
export default {
  name: 'App',
  components: {
    Navbar,
    Footer,
  }
}
</script>


<style>
body,
html {
  overflow-x: hidden !important;
}

.container {
  padding: 0 !important;
  height: 100%;
}
</style>
